import React, { Component } from 'react';
import { Popup, Item, Button, Modal, Header, Container, Icon, Dropdown, Image, Menu } from 'semantic-ui-react';
import * as LocalStorageManager from '../../util/StorageManager';
import { If } from '../../components/ConditionalRendering';
import { isDefined } from '../../util/Common';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import { Helmet } from "react-helmet";
import ItemLink from '../../components/ItemLink';
import OrcamentoVenda from '../OrcamentoVenda';
import PedidoVenda from '../PedidoVenda';
import Relatorios from '../Relatorios';
import Notas from '../Notas';
import { ToastContainer } from 'react-toastify';
import AuthService from "../../util/Authenticate";

import './home.css';
import semImagem from '../../sem-imagem.jpg';

class HomePage extends Component {

    constructor(){
        super();
        this.state = {
            activeItem: 'home',
            isModalSenhaOpen: true,
            selecionandoEmpresa: !isDefined(LocalStorageManager.getOrigem())
        }
    }

    componentDidMount(){
        const { documento, senha, isCliente } = LocalStorageManager.getLoggedUser();
        const tipoLogin = isCliente ? 'cliente' : 'representante';

        // Verifica se o usuario logado ainda eh valido
        AuthService.login(documento, senha, tipoLogin, (userData) => {
            if(!isDefined(userData) || !isDefined(userData.documento)){
                // Se o usuario nao for valido, faz o logout
                this.logout();
            }
        });
    }

    logout = () => {
        LocalStorageManager.clearUserState();
        this.props.history.push('/');
    }

    selecionarEmpresa = (origem) => {
        LocalStorageManager.setOrigem(origem);
        this.setState({ selecionandoEmpresa: false });
    }

    render() {
        const path = this.props.location.pathname;
        const user = LocalStorageManager.getLoggedUser();
        const { razaoSocial, logo, corBackground } = LocalStorageManager.getEmpresa();

        const HeaderEmpresa = () => (
            <Menu.Item position='right' className='no-margin' onClick={() => this.setState({ selecionandoEmpresa: isDefined(user.empresas) })}>
                <Header as='div' icon size='tiny'>
                    { isDefined(LocalStorageManager.getOrigem()) ? LocalStorageManager.getOrigem().nome : '' }
                    <Header.Subheader>
                        Empresa
                    </Header.Subheader>
                </Header>
            </Menu.Item>
        );

        return (  
            <div id='main' style={{ backgroundColor: corBackground }}>    
                <Helmet>
                    <title>{razaoSocial}</title>
                    <link rel="shortcut icon" href={logo}/>
                </Helmet>
                <Menu stackable icon fixed='top'>
                    <Menu.Item header>
                        <Image avatar src={logo}/>
                        <span>{razaoSocial}</span>
                    </Menu.Item>
                    <ItemLink to='/main' active={path === '/main'} icon='home'/>
                    <Dropdown item pointing text='Consultas'>
                        <Dropdown.Menu>
                            <ItemLink to='/main/notas' active={path === '/main/notas'} text='Notas Fiscais'/>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item pointing text='Pedidos'>
                        <Dropdown.Menu>
                            <ItemLink to='/main/orcamentos' active={path === '/main/orcamentos'} text='Orçamento'/>
                            <ItemLink to='/main/pedidos' active={path === '/main/pedidos'} text='Pedido'/>
                        </Dropdown.Menu>
                    </Dropdown>
                    <ItemLink to='/main/relatorios' active={path === '/main/relatorios'} text='Relatórios'/>  
                    <Menu.Item header position='right'>
                        <Header as='div' icon size='tiny' title={ user.documento }>
                            { user.documento }
                            <Header.Subheader title={ user.nome }>
                                { user.nome }
                            </Header.Subheader>
                        </Header>
                    </Menu.Item>     
                    <If test={isDefined(user.empresas)}>
                        <Popup inverted content='Clique para trocar de empresa' trigger={
                            <HeaderEmpresa />
                        }/>
                    </If>
                    <If test={!isDefined(user.empresas)}>
                        <HeaderEmpresa />
                    </If>
                    <Menu.Item onClick={this.logout} position='right'>
                        <Icon size='large' color='red' name='sign out'/>
                        Sair
                    </Menu.Item>
                </Menu>

                <Container fluid>
                    <ToastContainer newestOnTop={true} />
                    <Route path='/main/orcamentos' component={OrcamentoVenda}/>
                    <Route path='/main/pedidos' component={PedidoVenda}/>
                    <Route path='/main/relatorios' component={Relatorios}/>
                    <Route path='/main/notas' component={Notas}/>
                </Container>

                <Modal open={this.state.selecionandoEmpresa} dimmer='blurring' closeOnEscape={false} closeOnRootNodeClick={false}>
                    <Modal.Header>
                        Selecione a empresa
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <Item.Group divided>
                        {
                            isDefined(user.empresas) ? (
                                user.empresas.map((origem, index) => {
                                    return (
                                        <Item key={index}>
                                            <Item.Image size='tiny' src={isDefined(origem.logo) ? origem.logo : semImagem} />
                                            <Item.Content verticalAlign='middle'>
                                                <Item.Header>
                                                    {origem.nome}
                                                </Item.Header>
                                                <Item.Meta>
                                                    {/* Descrição da empresa */}
                                                </Item.Meta>
                                                <Item.Extra>
                                                    <Button primary floated='right' animated='vertical' onClick={() => this.selecionarEmpresa(origem)}>
                                                        <Button.Content hidden>
                                                            <Icon name='checkmark' color='green'/>
                                                            Selecionar
                                                        </Button.Content>
                                                        <Button.Content visible>
                                                            Selecionar
                                                        </Button.Content>
                                                    </Button>
                                                </Item.Extra>
                                            </Item.Content>
                                        </Item>
                                    )
                                })
                            ) : (
                                <Item>
                                    <Icon size='huge' name='warning sign' />
                                    <Item.Content verticalAlign='middle'>
                                        <Item.Header>
                                            Nenhuma empresa vinculada!
                                        </Item.Header>
                                        <Item.Meta>
                                            Solicite ao administrador a vinculação das empresas à este vendedor.
                                        </Item.Meta>
                                        <Item.Extra>
                                            <Button secondary floated='right' icon='sign out' content='Sair' onClick={this.logout}/>
                                        </Item.Extra>
                                    </Item.Content>
                                </Item>
                            )
                        }
                        </Item.Group>
                    </Modal.Content>
                </Modal>
            </div>
        )
    }
}

export default withRouter(HomePage);



// WEBPACK FOOTER //
// ./src/views/HomePage/index.js